module.exports = __webpack_public_path__ + "media/images/writer/home/home-01-a3e2a3f782651026917ad3eb6fd721ef.png";